const languageUrls = {
    fetchLanguages: {
        url: '/languages'
    },
    fetchLanguage: {
        url: '/languages/:id'
    },
    fetchFormOptions: {
        url: '/languages/actions/formOptions'
    },
    fetchTranslations: {
        url: '/languages/actions/lang'
    },
};
export default languageUrls;